export const BANNER_SPACE_PERCENTAGE = '50%';
export const LEFT_SIDEBAR_WIDTH = '350px';
